import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="overflow-hidden bg-black text-white bg-gradient-to-b from-[#000] to-black px-4 -mt-px">
      {/* Elementos de fondo específicos del footer */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl animate-pulse-slow"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo y nombre */}
          <div className="flex items-center space-x-3 mb-4 md:mb-0">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">&lt;&gt;</span>
            </div>
            <span className="text-lg font-bold">
              <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-blue-600 bg-clip-text text-transparent animate-gradient">OpenWeb</span>
              <span className="text-white"> Studio</span>
            </span>
          </div>
          
          {/* Derechos reservados */}
          <p className="text-gray-400 text-sm">
            © 2025 OpenWeb Studio. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 